export enum KeyCodes {
	ENTER_KEY = 13
}
